import { Checkbox, Grid } from "@mui/material";
import AssignPlanConfirmDialogs from "components/common/AssignPlan/AssignPlanConfirmDialogs";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";

import BackButton from "components/common/BackButton";
import BasicTable from "components/common/Table";
import Toggle from "components/common/Toggle";
import Typography from "components/common/Typography";
import ScrollableList from "components/common/plans/SelectedPlansList";
import { useTranslate } from "hooks/useTranslate";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE, includeAboveProperty } from "utils/CommonConstants";
import { getHltInncodes, getMoreValues, getPropertyName, getUserTypeValue } from "utils/CommonFunctions";
import { fetchAssigneeDetailsByInnCodesAsync, setAbovePropertyFilters } from "../../AboveProperty.slice";
import FilterButtons from "../../FilterButtons";
import "./AssignPlan.scss";
import { headers } from "./TableHeadersConfig";
interface props {
  SelectedPlansList?: any;
  isTemplatePlan?: boolean;
  individualPropertyInncode?: any;
}

function AssignPlan(props: any) {
  const {
    selectedPlanDetail,
    setOpenAssignPlanDialog,
    handleCloseDialog,
    showBackButton = false,
    handleBackState,
    SelectedPlansList,
    isTemplatePlan = false,
    individualPropertyInncode = "",
    flowSpecificPayload = {}
  } = props;
  const translate = useTranslate();
  const [checkedList, setCheckedList] = useState<any>([]);
  const [pageNo, setPageNo] = useState(0);

  const [openDialog, setOpenDialog] = useState<any>({ openAssignPlanDialog: true, openMessageDialog: false });
  const { planPropertyList, totalRecords: totalList } = useAppSelector((state) => state.aboveProperty.planProperty);
  const filters = useAppSelector((state: any) => state.aboveProperty.filters.dialogFilters.planAssignment);
  const dispatch = useAppDispatch();
  const handleChange = (element: any, event: React.ChangeEvent<HTMLInputElement>) => {
    let arr = [...checkedList];
    if (event.target.checked) {
      arr.push(element);
    } else {
      arr = arr.filter((el: any) => {
        if (!(el?.hltId === element?.hltId && el.innCodes[0] === element?.innCodes[0])) return el;
      });
    }

    setCheckedList(arr);
  };

  const handleAssignPlans = () => {
    setOpenDialog({ openAssignPlanDialog: false, openMessageDialog: true });
  };
  const getPlanPropertyList = async () => {
    const props = {
      searchText: filters.searchText,
      innCodes: [individualPropertyInncode]?.join(",") || filters?.property?.join(",") || getHltInncodes(true),
      page: pageNo,
      size: PAGE_SIZE,
      roles: filters?.role?.join(","),
      userType: getUserTypeValue(filters[includeAboveProperty]),
      ignoreNonFilteredInnCodes: true,
      respondWithHltIdAndInnCode: true
    };
    await dispatch(fetchAssigneeDetailsByInnCodesAsync(props));
  };

  useEffect(() => {
    getPlanPropertyList();
  }, [pageNo, filters]);

  useEffect(() => {
    setPageNo(0);
  }, [filters]);

  const onToggleChange = (parentView: string, filterType: string, value: boolean, name: string) => {
    dispatch(
      setAbovePropertyFilters({
        parentView: parentView,
        filterType: filterType,
        filterName: name,
        value: value
      })
    );
  };

  return (
    <>
      {openDialog.openAssignPlanDialog && (
        <DialogFormation
          title={translate("dashboard.planAssignment.user")}
          openDialog={openDialog?.openAssignPlanDialog}
          contentClass="dialogContentStyle"
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper-with-back">
              {showBackButton && (
                <BackButton
                  label={"Back"}
                  onClick={handleBackState}
                  color={tokens.Text.General.Color}
                  isButtonVisible={showBackButton}
                ></BackButton>
              )}
              <Button
                disabled={!checkedList.length}
                variant="primary"
                label="Next"
                sx={{ marginLeft: "auto" }}
                onClick={handleAssignPlans}
                endIcon={
                  checkedList.length > 0 && (
                    <div className="next-count">
                      <Typography variant={"body2"} showBold>
                        {checkedList.length}
                      </Typography>
                    </div>
                  )
                }
              />
            </div>
          }
        >
          <Grid maxHeight={"500px"}>
            <FilterButtons
              searchBarPlaceHolder={"Search by member’s name"}
              searchPredefinedValue={filters.searchText}
              isRoleVisible
              isPropertyVisible={!individualPropertyInncode}
              isSearchBarVisible
              parentView="dialogFilters"
              filterType="planAssignment"
            />
            <div className="toggle">
              <Toggle
                onChange={(val: boolean) =>
                  onToggleChange("dialogFilters", "planAssignment", val, includeAboveProperty)
                }
                labelOn={translate("common.includeAboveProperty")}
                labelOff={translate("common.excludeAboveProperty")}
                isToggleEnabled={filters[includeAboveProperty]}
                isLabelLeftSide
                sx={{ marginLeft: "8px" }}
              />
            </div>

            {checkedList.length ? (
              <Grid display="flex" justifyContent="flex-end" alignItems="center">
                <Typography variant="body2" showBold color={tokens.Text.General.Secondary}>
                  {checkedList?.length} user selected
                </Typography>
                <ScrollableList
                  options={checkedList}
                  handleChange={(option: any, i: number) => {
                    const newData = checkedList.filter((_: any, index: number) => index !== i);
                    setCheckedList(newData);
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                ></ScrollableList>
              </Grid>
            ) : null}

            <BasicTable
              scrollableTarget="actionItemsDivMobile"
              totalRecords={totalList}
              pagination={{ pageNo: pageNo, setPageNo: setPageNo }}
              dataLength={planPropertyList?.length}
              scroll
              data={{
                headers,

                rows: planPropertyList?.map((element: any) => {
                  return {
                    data: [
                      {
                        content: (
                          <Grid display="flex" flexDirection={"row"} width="180px">
                            <Checkbox
                              onChange={(event: any) => handleChange(element, event)}
                              checked={
                                checkedList?.findIndex(
                                  (el: any) => el.hltId === element.hltId && el.innCodes[0] === element.innCodes[0]
                                ) > -1
                              }
                            />

                            <Typography sx={{ marginTop: "8px" }}> {element?.displayName}</Typography>
                          </Grid>
                        )
                      },

                      {
                        content: getMoreValues(element?.roles),
                        tooltip: {
                          title: "Role",
                          list: element?.roles?.map((owner: any) => {
                            return { name: owner };
                          })
                        }
                      },
                      { content: getPropertyName(element?.innCodes?.[0]) },
                      { content: element?.innCodes?.[0] }
                    ]
                  };
                })
              }}
            />
          </Grid>
        </DialogFormation>
      )}
      {openDialog.openMessageDialog && (
        <AssignPlanConfirmDialogs
          handleCloseState={setOpenAssignPlanDialog}
          selectedList={checkedList}
          SelectedPlansList={showBackButton ? SelectedPlansList : [selectedPlanDetail]}
          handleBackState={setOpenDialog}
          onCloseConfirm={() => null}
          innCode={individualPropertyInncode}
          isTemplatePlan={isTemplatePlan}
          flowSpecificPayload={flowSpecificPayload}
        />
      )}
    </>
  );
}
export default AssignPlan;
